import { render, staticRenderFns } from "./FullCalendar.vue?vue&type=template&id=4dd3d768&scoped=true&"
import script from "./FullCalendar.vue?vue&type=script&lang=js&"
export * from "./FullCalendar.vue?vue&type=script&lang=js&"
import style0 from "./FullCalendar.vue?vue&type=style&index=0&id=4dd3d768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd3d768",
  null
  
)

export default component.exports